import { CUSTOM_PROFILE_ID } from '@lib/transfers/store/preferences-slice';
import type { SolverProfile } from '@api-service/recommendations';

export const CUSTOM_PROFILE_LABEL = 'Custom';

/** Backend profile names are lower-case machine names; e.g. 'optimised'. */
export const profileLabelFor = (name: string): string =>
  name.charAt(0).toUpperCase() + name.slice(1);

/**
 * The label of the profile currently driving recommendations: the member's
 * selection when they have one, else the backend's default profile.
 */
export const resolveActiveProfileLabel = (
  selectedProfileId: string | null,
  profiles: SolverProfile[]
): string => {
  if (selectedProfileId === CUSTOM_PROFILE_ID) return CUSTOM_PROFILE_LABEL;

  const defaultProfile =
    profiles.find((profile) => profile.isDefault) ?? profiles[0] ?? null;
  const activeProfile =
    profiles.find((profile) => profile.name === selectedProfileId) ??
    defaultProfile;

  return activeProfile ? profileLabelFor(activeProfile.name) : '';
};
